;(function( $ ) {
	'use strict';
	$( document ).ready( function() {
		$( '.entry-content, .article-body' ).fitVids(
			{
				customSelector: [
					"iframe[src^='http://www.facebook.com/plugins/video.php']",
					"iframe[src^='http://www.brightcove.com']",
					"iframe[src^='http://bcove.me']",
					"iframe[src^='http://link.brightcove.com']",
					"iframe[src^='http://blip.tv']",
					"iframe[src^='http://d.yimg.com']",
					"iframe[src^='http://www.dailymotion.com']",

					"iframe[src^='https://www.facebook.com/plugins/video.php']",
					"iframe[src^='https://www.brightcove.com']",
					"iframe[src^='https://bcove.me']",
					"iframe[src^='https://link.brightcove.com']",
					"iframe[src^='https://blip.tv']",
					"iframe[src^='https://d.yimg.com']",
					"iframe[src^='https://www.dailymotion.com']"
				].join( ',' )
			} );

		$( '.faq-list' ).each( function() {
			var $this = $( this );

			$this.children( 'li' ).click( function() {
				// Add a class to the root item to tell us we're using JS now so we can stop with the CSS hacks
				$this.addClass( 'running' );

				$( this )
					.addClass( 'active' )
					.siblings()
					.removeClass( 'active' );
			} );
		} );

		var evnt, $body = $( 'body' );
		$( 'input[name="menu-toggle"]' ).on( 'change', function() {

			clearTimeout( evnt );

			// If the currently active menu input has a value of "full" we should tell everyone.
			if ( $( this ).val() === 'full' ) {
				// We need to wait a moment before adding the overlay class
				evnt = setTimeout( function() {
					$body.addClass( 'overlayed' );
				}, 250 );
			}
			else {
				// Remove it immediately
				$body.removeClass( 'overlayed' );
			}
		} );


//		var rsz, $sub = $( '#sub-menu-off' ), $window = $( window ), w = $window.width();
//		/* If the screen is re-sized we need to turn the menu off */
//		$window.on( 'resize', window, function() {
//			clearTimeout( rsz );
//			rsz = setTimeout( function() {
//				var newW = $window.width();
//				// But only if the width passes the breakpoint
//				if ( (w < 768 && newW >= 768) || (w >= 768 && newW < 768) ) {
//					w = newW;
//					$sub.prop( 'checked', true ).trigger( 'change' );
//				}
//			}, 200 );
//		} );

		// Move the align class from the image down to the anchor wrapping the image
		$( '.article-body a[rel^="attachment"], .article-body a[rel*=" attachment"]' )
			.each( function() {
				var $this  = $( this ),
					$child = $this.children( 'img.alignleft, img.alignright' );

				if ( $child.length ) {
					if ( $child.hasClass( 'alignleft' ) ) {
						$this.addClass( 'alignleft' );
						$child.removeClass( 'alignleft' );
					}
					else {
						$this.addClass( 'alignright' );
						$child.removeClass( 'alignright' );
					}
				}
			} );


		// Auto adjust iFrame according to content,
		// Make sure to move iframeResizer.js into tools and that iframeResizer.contentWindow.js is in the target iframe
		$( 'iframe' ).iFrameResize( [ {
			log: false,
			autoResize: false,
			heightCalculationMethod: 'bodyScroll',
			scrolling: true
		} ] );

        /**
         * Group the profile small image widgets in a constrained wrapper
         */
		$(':not(.image-widget-extensions-7) + .image-widget-extensions-7, * > .image-widget-extensions-7:first-of-type').
		each(function() {
			$(this).
			nextUntil(':not(.image-widget-extensions-7)').
			addBack().
			wrapAll('<div class="image-widget-extensions-wrapper constrained" />');
		});

        /**
		 * Scroll to the top of the page
         */
        $(window).scroll(function() {
            if ($(this).scrollTop() >= 50) {
                $('#scroll-to-top').addClass('stt-visible');
            } else {
                $('#scroll-to-top').removeClass('stt-visible');
            }
        });

        $('#scroll-to-top').click( function(e) {
            e.preventDefault();
            $('body, html').animate({
                scrollTop : 0
            }, 600);
        });

    } );
}( jQuery ));
